import isMiniProgramUserAgent from "@Utils/isMiniProgramUserAgent";

/**
 * True when the page is running inside the WeChat mini program WebView.
 * Uses UA (SSR-hydrated) and the weixin.js SDK when available.
 */
const isWeChatMiniProgramClient = (): boolean => {
  if (typeof window === "undefined") return false;
  if (isMiniProgramUserAgent()) return true;
  // @ts-ignore — weixin.js SDK injected in mini program WebView
  return Boolean(window.wx?.miniProgram);
};

export default isWeChatMiniProgramClient;
